import 'css-chunksrc/client/scenes/workloads/header/filters/dataTypeFilter/styles.scss';export default {
  "dataTypeFilter": "_dataTypeFilter_k8p6f_1",
  "input": "_input_k8p6f_7",
  "toggleArrow": "_toggleArrow_k8p6f_23",
  "selectedDataTypes": "_selectedDataTypes_k8p6f_31",
  "placeholder": "_placeholder_k8p6f_40",
  "list": "_list_k8p6f_45",
  "item": "_item_k8p6f_57",
  "typeName": "_typeName_k8p6f_70",
  "opened": "_opened_k8p6f_77"
};